export default __webpack_public_path__ + "static/chocpops-taste-2-desktop-2e2ca4a6ee07915635f04a5efd1bddee.png";